const filterObjectsById = (objectId: string, objects: Array<{ id: string }>) => objects.filter(o => o.id !== objectId);

export default filterObjectsById;
